import { Request } from '../request';
import {
    TUpcomingAppointmentRequest,
    TUnreadMessagesResponse,
    TAppointmentTrendRequest,
    TPerformanceResponse,
    TreatmentPlanAppointmentCountsResponse,
    TTreatmentPlanAppointmentQueryReq,
    TreatmentPlanItemListResponse,
} from 'types/home';

export enum ETimeType {
    THIS_WEEK = 'LAST_7_DAYS',
    LAST_14_DAYS = 'LAST_14_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS',
    LAST_90_DAYS = 'LAST_90_DAYS',
}

export const getDashboard = (timeSelection: number) =>
    Request.get({ url: `/schedule-server/provider/home/dashboard/${timeSelection}`, disableErrorNote: true });
export const getTasksStatus = () => Request.get({ url: '/schedule-server/provider/home/task/status' });
export const getQuickAction = () => Request.get({ url: 'schedule-server/provider/home/quick-actions' });
export const getUpcomingAppointments = (params: TUpcomingAppointmentRequest) =>
    Request.post<TUpcomingAppointmentRequest>({ url: '/schedule-server/provider/home/appointment/upcoming', params });
export const getUnreadMessages = () =>
    Request.get<TUnreadMessagesResponse>({ url: '/schedule-server/provider/home/message/unread' });
export const getAppointmentTrends = (params: TAppointmentTrendRequest) =>
    Request.post<TAppointmentTrendRequest>({ url: '/schedule-server/provider/home/appointment/trend', params });
export const getAvailableHoursInNextNHours = (hours: number) =>
    Request.get<{ hours: number }>({
        url: '/schedule-server/provider/home/getAvailableHoursInNextNHours',
        params: { hours },
        disableErrorNote: true,
    });
export const getPerformance = (weeks: number) =>
    Request.get<TPerformanceResponse>({
        url: `/schedule-server/provider/home/performance/${weeks}`,
        disableErrorNote: true,
    });

// 获取治疗计划预约计数（新接口）
// appointmentOnly=true 只统计 provider appointment、过滤 text visit（Insurance billing 入口用）
export const getTreatmentPlanAppointmentCounts = (clientId?: number, appointmentOnly?: boolean) =>
    Request.get<{ clientId?: number; appointmentOnly?: boolean }>({
        url: '/schedule-server/provider/treatment-plan/appointment/counts',
        params:
            clientId || appointmentOnly
                ? { clientId: clientId || undefined, appointmentOnly: appointmentOnly || undefined }
                : undefined,
        disableErrorNote: true,
    }) as Promise<{
        success: boolean;
        error?: string;
        errorCode?: number;
        data?: TreatmentPlanAppointmentCountsResponse;
    }>;

// 获取治疗计划项列表（聚合Appointments和Text Visits，后端分页）
export const getTreatmentPlanItemList = (params: TTreatmentPlanAppointmentQueryReq) =>
    Request.post<TTreatmentPlanAppointmentQueryReq>({
        url: '/schedule-server/provider/treatment-plan/appointment/pageList',
        params,
        disableErrorNote: true,
    }) as Promise<{ success: boolean; error?: string; errorCode?: number; data?: TreatmentPlanItemListResponse }>;
